// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   Sistema de Breakpoints Globales para SGEweb
   ============================================ */

:root {
  /* Breakpoints estándar para diseño responsive */
  --breakpoint-xs: 480px; /* Móviles pequeños (iPhone SE, etc.) */
  --breakpoint-sm: 768px; /* Tablets y móviles grandes */
  --breakpoint-md: 1024px; /* Tablets horizontales y laptops pequeñas */
  --breakpoint-lg: 1440px; /* Pantallas grandes (desktop estándar) */
  --breakpoint-xl: 1920px; /* Pantallas extra grandes (Full HD) */

  /* Espaciado responsive */
  --spacing-mobile: 8px;
  --spacing-tablet: 12px;
  --spacing-desktop: 16px;

  /* Tamaños de fuente responsive */
  --font-size-mobile: 0.85rem;
  --font-size-tablet: 0.9rem;
  --font-size-desktop: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/styles/breakpoints.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD;EACE,gDAAgD;EAChD,sBAAsB,EAAE,uCAAuC;EAC/D,sBAAsB,EAAE,8BAA8B;EACtD,uBAAuB,EAAE,4CAA4C;EACrE,uBAAuB,EAAE,yCAAyC;EAClE,uBAAuB,EAAE,sCAAsC;;EAE/D,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;;EAEvB,iCAAiC;EACjC,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;AAC3B","sourcesContent":["/* ============================================\n   Sistema de Breakpoints Globales para SGEweb\n   ============================================ */\n\n:root {\n  /* Breakpoints estándar para diseño responsive */\n  --breakpoint-xs: 480px; /* Móviles pequeños (iPhone SE, etc.) */\n  --breakpoint-sm: 768px; /* Tablets y móviles grandes */\n  --breakpoint-md: 1024px; /* Tablets horizontales y laptops pequeñas */\n  --breakpoint-lg: 1440px; /* Pantallas grandes (desktop estándar) */\n  --breakpoint-xl: 1920px; /* Pantallas extra grandes (Full HD) */\n\n  /* Espaciado responsive */\n  --spacing-mobile: 8px;\n  --spacing-tablet: 12px;\n  --spacing-desktop: 16px;\n\n  /* Tamaños de fuente responsive */\n  --font-size-mobile: 0.85rem;\n  --font-size-tablet: 0.9rem;\n  --font-size-desktop: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
